import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient from "../lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = useCallback(() => {
    apiClient.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ settings, refresh: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
